<template>
  <page-header-wrapper>

    <a-card
      style="margin-top: 24px"
      :bordered="false"
      :title="$t('message.transform.authList')">

      <a-list size="large">
        <a-list-item :key="index" v-for="(item, index) in platforms">
          <a-list-item-meta :description="item.description">
            <a-avatar slot="avatar" size="large" shape="square" :src="item.picture"/>
            <a slot="title" @click="getUrl(item)">{{ item.title }}</a>
          </a-list-item-meta>
          <div class="list-content">
            <div slot="actions">
              <a @click="getUrl(item)">{{$t('message.transform.auth')}}</a>
            </div>
          </div>
          <div slot="actions" @mouseover="getAuthData(item.platform)">
            <a-dropdown>
              <a>{{$t('message.transform.authStore')}}
                <a-icon type="down"/>
              </a>
              <a-menu slot="overlay" id="shopName">
                <template v-for="shopname in shopNames">
                  <a-menu-item>{{ shopname }}</a-menu-item>
                </template>
                <!--                  <a-menu-item>{{item.shop.shopMy}}</a-menu-item>-->
              </a-menu>
            </a-dropdown>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
  </page-header-wrapper>
</template>

<script>
// 演示如何使用 this.$dialog 封装 modal 组件
import TaskForm from './TaskForm'
import Info from './Info'
import Lazada from '../../assets/country/LZD2.png'
import AE from '../../assets/country/AliExpress.png'
import request from '../../utils/request'

export default {
  name: 'StandardList',
  components: {
    TaskForm,
    Info
  },
  computed: {
    platforms () {
      let res = []
      res.push({
        title: 'LAZADA',
        platform: 'LAZADA',
        shortPlatform: 'LZD',
        picture: Lazada,
        description: this.$t('message.transform.lzd.description')
      }, {
        title: 'AE',
        platform: 'AEG',
        shortPlatform: 'AEG',
        picture: AE,
        description: this.$t('message.transform.ae.description')
      })
      return res
    }
  },
  data () {
    return {
      status: 'all',
      shopNames: [],
      current: 0
    }
  },
  methods: {
    getUrl (item) {
      request({
        url: '/authorization/end/auth?platform=' + item.shortPlatform + '&fromPage=auth',
        method: 'get'
      })
    },
    getAuthData: function (platform) {
      request({
        url: '/shipper/shopName?platform=' + platform,
        method: 'get'
      }).then(response => {
        this.shopNames = response.data.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-avatar-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;

  span {
    line-height: 20px;
  }

  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/authorization/authorization.vue